import { render, staticRenderFns } from "./PermissionTab.vue?vue&type=template&id=32e5f6a2&scoped=true&"
import script from "./PermissionTab.vue?vue&type=script&lang=js&"
export * from "./PermissionTab.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTab.vue?vue&type=style&index=0&id=32e5f6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e5f6a2",
  null
  
)

export default component.exports